export default "__VITE_ASSET__fHGwfbuc__"